import { Box, Button, styled, Typography } from "@mui/material";
import { X } from "@phosphor-icons/react";
import React, { useEffect } from "react";
import { useData } from "../../hooks/StateContext";
import { listAllFlavour, listAllWeight } from "../../utilities";

const QuantityButton = styled(Button)(() => ({
  border: "1px solid var(--neutral-400)",
  borderRadius: "8px",
  padding: "8px 12px",
  fontWeight: 500,
  fontSize: "16px",
  color: "var(--neutral-800)",
  height: "44px",
  lineHeight: "120%",
  backgroundColor: "rgba(247, 247, 247, 0.5)",
  "&:hover": {
    backgroundColor: "#FFFFFF",
    transform: "scale(1.01, 1.01)",
    transformOrigin: "center center",
    transition: "0.1s ease-in",
    fontWeight: 600,
  },
}));
function MobileFilterWrapper({ filterValues, setFilterValues, data }) {
  const {
    appData: { listing },
    setAppData,
  } = useData();
  const initialWeightList = listing?.weightList;
  const handleWeightRadioChange = (value) => {
    setFilterValues((prev) => {
      if (prev?.weight) {
        if (!prev.weight.includes(value)) {
          const updatedWeight = [...prev.weight, value];
          return { ...prev, weight: updatedWeight };
        } else {
          let updatedWeight = prev.weight.filter((item) => item !== value);
          if (updatedWeight?.length == 0) updatedWeight = null;
          return { ...prev, weight: updatedWeight };
        }
      } else {
        const updatedWeight = value !== null ? [value] : null;
        return { ...prev, weight: updatedWeight };
      }
    });
  };
  const weightList = data && listAllWeight(data);
  let flavourList = data && listAllFlavour(data);
  useEffect(() => {
    if (weightList?.length > 0 && initialWeightList?.length == 0) {
      setAppData((prev) => ({
        ...prev,
        listing: {
          weightList: weightList,
        },
      }));
    }
  }, [weightList]);

  const handleReset = () => {
    setFilterValues((prev) => ({ ...prev, weight: null, flavour: null }));
    setAppData((prev) => ({
      ...prev,
      listing: {
        weightList: [],
      },
    }));
  };
  return (
    <Box sx={{ width: "100%", p: 2 }}>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "16px",
          color: "var(--neutral-black)",
          textAlign: "left",
          lineHeight: "150%",
          textTransform: "capitalize",
          mb: 2,
        }}
      >
        Filter
      </Typography>
      <Box sx={{ columnGap: 2, display: "flex", flexWrap: "wrap" }}>
        {initialWeightList?.map((weight, index) => {
          const isSelected = filterValues?.weight?.includes(weight.weight_id);
          return (
            <QuantityButton
              key={index}
              onClick={() => handleWeightRadioChange(weight?.weight_id)}
              variant="outlined"
              //   endIcon={
              //     <X
              //       size={10}
              //       weight="bold"
              //       color={isSelected ? "black" : "white"}
              //     />
              //   }
              sx={{
                minWidth: "80px",
                fontWeight: isSelected ? 600 : 500,
                border: isSelected && "1px solid var(--primary-red-base)",
                color: isSelected && "var(--neutral-black)",
                backgroundColor: isSelected && "rgba(255, 212, 213, 0.48)",
              }}
            >
              {`${weight?.weight_name} ${weight?.unit_name}`}
            </QuantityButton>
          );
        })}
      </Box>
    </Box>
  );
}

export default MobileFilterWrapper;
